import { render, staticRenderFns } from "./wechatAudio.vue?vue&type=template&id=89d41956&scoped=true&"
import script from "./wechatAudio.vue?vue&type=script&lang=ts&"
export * from "./wechatAudio.vue?vue&type=script&lang=ts&"
import style0 from "./wechatAudio.vue?vue&type=style&index=0&id=89d41956&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d41956",
  null
  
)

export default component.exports